import { useState } from "react";
import ToggleTabs from "../../utility/ChartTableToggle";
import { SearchBox } from "../../../../../components/Search";
import QuantumSummaryTable from "./QuantumTable";
import CostSummaryTable from "./CostTable";

const DataTabs = ["Quantum", "Cost"];

export default function AnnualSummaryTable({
  refreshKey,
  setError,
}: {
  refreshKey: number;
  setError?: any;
}) {
  const [activeTab, setActiveTab] = useState<string>(DataTabs[0]);
  const [selectedMonths, setSelectedMonths] = useState<any[]>([]);
  const [availableMonths, setAvailableMonths] = useState<any[]>([]);

  return (
    <div className="dash-card col-span-1 md:col-span-12 border border-[#718EBF1C] !bg-[#fff] !p-2 !min-h-[100%] w-full">
      <div className="flex justify-between items-center mb-2 border-b border-[#DFEAF2] pb-2">
        <h2 className="chartHeading !text-sm">Annual Metrics</h2>
        <div className="flex items-center gap-2">
          <SearchBox
            options={availableMonths}
            isMany={true}
            placeholder="Search Month"
            selectedOptions={selectedMonths}
            onChange={setSelectedMonths}
          />
          <ToggleTabs
            tabs={DataTabs}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        </div>
      </div>

      {/* Render Quantum or Cost table based on active tab */}
      {activeTab === DataTabs[0] ? (
        <QuantumSummaryTable
          refreshKey={refreshKey}
          setError={setError}
          selectedMonths={selectedMonths}
          setSelectedMonths={setSelectedMonths}
          setAvailableMonths={setAvailableMonths}
        />
      ) : (
        <CostSummaryTable
          refreshKey={refreshKey}
          setError={setError}
          selectedMonths={selectedMonths}
          setSelectedMonths={setSelectedMonths}
          setAvailableMonths={setAvailableMonths}
        />
      )}
    </div>
  );
}